module.exports = __webpack_public_path__ + "img/Sad_Bird.66ef8698.png";